/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx, Flex, Text } from 'theme-ui'

const IconListSection = ({ bgOverride, title, subtitle }) => {
  // The four lower items are separated by "_" within the Subtitle field.
  const subtitlePieces = subtitle.split('!')
  const items = subtitlePieces[0].split('_')
  const icons = items.map((listItem) => listItem.split('|')[0])
  const labels = items.map((listItem) => listItem.split('|')?.[1])
  const topBackground = subtitlePieces[1]
  const iconDimensions = {
    award: {
      height: '51px',
      width: '66px',
    },
    can: {
      height: '48px',
      width: '48px',
    },
    cheers: {
      height: '47px',
      width: '44px',
    },
    'heart-hands': {
      height: '42px',
      width: '46px',
    },
    shipping: {
      height: '35px',
      width: '51px',
    },
    sugar: {
      height: '45px',
      width: '45px',
    },
  }

  const iconImages = icons.map((icon, index) => (
    <img
      src={`/images/icons/${icons[index]}.svg`}
      alt=""
      aria-hidden="true"
      sx={{ height: '48px', width: '48px', ...iconDimensions?.[icon] }}
    />
  ))

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {items && (
        <Box
          bg="backgroundBright"
          pt={[9, 8]}
          pb={[10, 8]}
          sx={{
            position: 'relative',
            '&:before': {
              backgroundImage: `url('/images/backgrounds/icon-list-background-top-${topBackground}.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              content: '""',
              display: 'block',
              height: '32px',
              left: '50%',
              pointerEvents: 'none',
              position: 'absolute',
              top: 0,
              transform: 'translateX(-50%)',
              width: '2000px',
            },
            '&:after': {
              backgroundColor: bgOverride ? bgOverride : 'backgroundLight',
              backgroundImage: `url('/images/backgrounds/icon-list-background-bottom.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              bottom: '0',
              content: '""',
              display: 'block',
              height: '32px',
              left: '50%',
              pointerEvents: 'none',
              position: 'absolute',
              transform: 'translateX(-50%)',
              width: '2000px',
            },
          }}
        >
          <Container>
            {title && (
              <Heading
                as="h2"
                variant="title2"
                mb={[3, 4, 5]}
                sx={{ textAlign: 'center' }}
              >
                {title}
              </Heading>
            )}
            <Grid columns={[2, 4]} sx={{ rowGap: 5 }}>
              {items.map((item, index) => {
                return (
                  <Flex
                    key={index}
                    px={[1, null, null, 2]}
                    sx={{
                      alignItems: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <Flex
                      mb={[2, null, 0]}
                      sx={{
                        backgroundImage: `url('/images/backgrounds/icon-list-item-blob-${
                          index + 1
                        }.svg')`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        alignItems: 'center',
                        flexDirection: 'column',
                        height: ['100px', null, '164px', '203px'],
                        justifyContent: 'center',
                        position: 'relative',
                        width: ['108px', null, '177px', '219px'],
                      }}
                    >
                      {iconImages[index]}
                      <Text
                        as="p"
                        variant="callout1"
                        mt={[null, null, 1, 2]}
                        sx={{
                          display: ['none', null, 'block'],
                          maxWidth: [null, null, '124px', '180px'],
                          textAlign: 'center',
                        }}
                      >
                        {labels[index]}
                      </Text>
                    </Flex>
                    <Text
                      as="p"
                      variant="callout1"
                      sx={{
                        display: [null, null, 'none'],
                        textAlign: 'center',
                      }}
                    >
                      {labels[index]}
                    </Text>
                  </Flex>
                )
              })}
            </Grid>
          </Container>
        </Box>
      )}
    </Box>
  )
}

export default IconListSection
